import React, { useState } from 'react';
import { Box, TextField, Button, Stack, CircularProgress } from '@mui/material';
import { UpdateOutlined, CloseOutlined } from '@mui/icons-material';
import { updateMeasurement } from '../../../../helpers/api';
import { message } from 'antd'; // Using antd message for consistency with your notification style
import '../style.css';

const EditMeasurementForm = ({ closeModal, reload, name, id }) => {
  const [loading, setLoading] = useState(false);
  const [measurementName, setMeasurementName] = useState(name || '');

  const handleUpdate = (e) => {
    e.preventDefault();
    if (!measurementName.trim()) return;

    setLoading(true);
    const payload = {
      measurementName: measurementName.trim().toLowerCase(),
    };

    updateMeasurement(payload, id)
      .then((res) => {
        message.success(`Update successful!`);
        setLoading(false);
        reload();
        closeModal();
      })
      .catch((error) => {
        message.error('Something went wrong');
        setLoading(false);
      });
  };

  return (
    <Box component="form" onSubmit={handleUpdate} sx={{ mt: 1 }}>
      <Stack spacing={3}>
        <TextField
          fullWidth
          label="Measurement Name"
          placeholder="Enter new measurement name"
          variant="outlined"
          value={measurementName}
          onChange={(e) => setMeasurementName(e.target.value)}
          required
          autoFocus
          disabled={loading}
          slotProps={{
            input: {
              sx: { borderRadius: '10px' },
            },
            inputLabel: {
              shrink: true,
            },
          }}
        />

        <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
          <Button
            variant="text"
            color="inherit"
            onClick={closeModal}
            disabled={loading}
            startIcon={<CloseOutlined />}
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              borderRadius: '8px',
              px: 3,
            }}
          >
            Cancel
          </Button>

          <Button
            type="submit"
            variant="contained"
            disableElevation
            disabled={loading || !measurementName.trim() || measurementName === name}
            startIcon={
              loading ? <CircularProgress size={18} color="inherit" /> : <UpdateOutlined />
            }
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              borderRadius: '8px',
              px: 4,
              bgcolor: 'info.main',
              '&:hover': { bgcolor: 'info.dark' },
            }}
          >
            {loading ? 'Updating...' : 'Update Measurement'}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default EditMeasurementForm;
